import { BasePlane } from '@App/app/entities/layer/base-plane.model';
import { Component } from '@angular/core';
import { BaseLayerPropertiesComponent } from '../base-layer-properties/base-layer-properties.component';

@Component({
  selector: 'app-base-plane-properties',
  templateUrl: './base-plane-properties.component.html',
})
export class BasePlanePropertiesComponent extends BaseLayerPropertiesComponent<BasePlane> {}
